import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { createApi } from "@reduxjs/toolkit/query/react";

const teamOverviewApi = createApi({
    reducerPath: "teamOverviewApi",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        getTeamMemberOverviewByTeamId: builder.mutation({
            query: (teamId) => ({
                url: `/TeamMembers/GetTeamMemberOverviewByTeamId?TeamId=${teamId}`,
                method: "GET",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getTeamOverviewDetails: builder.mutation({
            query: (teamId) => ({
                url: `/Teams/GetTeamOverviewDetails?TeamId=${teamId}`,
                method: "GET",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getTeamOverviewMemberDetails: builder.mutation({
            query: (teamId) => ({
                url: `/Teams/GetTeamOverviewMemberDetails?TeamId=${teamId}`,
                method: "GET",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getTeamOverviewDashboard: builder.mutation({
            query: (body) => ({
                url: `/Teams/GetTeamOverviewDashboard`,
                method: "POST",
                body,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useGetTeamMemberOverviewByTeamIdMutation,
    useGetTeamOverviewDetailsMutation,
    useGetTeamOverviewMemberDetailsMutation,
    useGetTeamOverviewDashboardMutation,
} = teamOverviewApi;
export default teamOverviewApi;
